// extracted by mini-css-extract-plugin
export default {"networkProfilePicture":"group_networkProfilePicture__a5F6u"};